import { render } from "./PrintPartyBlock.vue?vue&type=template&id=a4f5f8f8&scoped=true"
import script from "./PrintPartyBlock.vue?vue&type=script&lang=js"
export * from "./PrintPartyBlock.vue?vue&type=script&lang=js"

import "./PrintPartyBlock.vue?vue&type=style&index=0&id=a4f5f8f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4f5f8f8"]])

export default __exports__